import React from 'react';
import StudyOverlay from '../Components/StudyOverlay';
import { Teaser } from '../Components/Teaser';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { getPath } from '../Util/Paths';

export class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      studyplan: props.studyplan,
      showOverlay: false,
    };

    changeStateMobileAccordeon(true);
  }

  showOverlay = () => {
    this.setState({ showOverlay: true });
  };
  closeOverlay = () => {
    this.setState({ showOverlay: false });
  };

  render() {
    return (
      <Router hashType="noslash">
        <Teaser
          imageUrl={this.state.studyplan[0].images[0]}
          downloads={this.state.studyplan[0].downloads}
          showOverlayHandler={this.showOverlay}
          studyplans={this.state.studyplan}
        />
        <Switch>
          <Route
            path={getPath('studyplan')}
            render={(routerProps) => {
              return (
                <StudyOverlay
                  show={this.state.showOverlay}
                  studyplan={this.state.studyplan.find(
                    ({ uid }) =>
                      parseInt(routerProps.match.params.studyplan) === uid
                  )}
                  closeHandler={this.closeOverlay}
                />
              );
            }}
          />
        </Switch>
      </Router>
    );
  }
}

export const changeStateMobileAccordeon = (open) => {
  let parent = document.querySelector('.studyplan').parentNode;

  if (!parent) {
    return;
  }
  while (parent) {
    if (
      parent.nodeType === 1 &&
      parent.classList.contains('MobileContentAccordionHeaderWrapper') &&
      location.hash.match('studyplan')
    ) {
      parent.classList.toggle(
        'MobileContentAccordionHeaderWrapper--active',
        open
      );
      return;
    }
    parent = parent.previousSibling;
  }
};
